import * as React from "react";
import * as classnames from "classnames";
var ModalHeader = function (_a) {
    var _b = _a.addOn, addOn = _b === void 0 ? null : _b, _c = _a.header, header = _c === void 0 ? "" : _c, _d = _a.subHeader, subHeader = _d === void 0 ? "" : _d, _e = _a.stretched, stretched = _e === void 0 ? false : _e;
    if (subHeader && addOn) {
        throw new Error("You cannot have both subHeader and addon");
    }
    else if (!header && subHeader) {
        throw new Error("You must provide a header if you provide a subHeader");
    }
    var classNames = classnames("wds-modal__addon", {
        "wds-modal__addon--stretched": stretched || !header
    });
    return (React.createElement("header", { className: "wds-modal__head" },
        React.createElement("div", { className: "wds-modal__title" },
            header && React.createElement("h1", { className: "wds-modal__text" }, header),
            subHeader && React.createElement("p", { className: "wds-modal__sub-text" }, subHeader),
            addOn && React.createElement("div", { className: classNames }, addOn))));
};
export default ModalHeader;
//# sourceMappingURL=ModalHeader.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Modal/ModalHeader.js
// module id = 1800
// module chunks = 17